export default __webpack_public_path__ + "assets/background-images-2025-portrait.ca8647c2.jpg";